var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"backoffice-layout"},[_c('navigation-bars-login'),_vm._v(" "),_c('v-main',{staticClass:"h-100"},[_c('nuxt')],1),_vm._v(" "),_c('confirm',{ref:"confirm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }